import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

const QuickSelection = props => {
    const list1 = props.rangeList.filter((_, i) => i < 12);
    const list2 = props.rangeList.filter((_, i) => i >= 12);
    const path = `${props.location.pathname}${props.location.search}`;
    const { customRange } = props.searchParams;

    return (<Row className="mt-3">
        <Col sm={4} lg={4} md={4}>
            <ul>
                {list1.map(item => (<li className="list-item" key={item.id}>
                    <span className={`${customRange === item.id ? "item-active" : ""}`}>
                        <NavLink
                            className="list-text"
                            {...{
                                to: path,
                                onClick: () => props.onChange(item)
                            }}>
                            {item.name}
                        </NavLink>
                    </span>
                </li>)
                )}
            </ul>
        </Col>
        <Col sm={4} lg={4} md={4}>
            <ul>
                {list2.map(item => (<li className="list-item" key={item.id}>
                    <span className={`${customRange === item.id ? "item-active" : ""}`}>
                        <NavLink
                            className="list-text"
                            {...{
                                to: path,
                                onClick: () => props.onChange(item)
                            }}>
                            {item.name}
                        </NavLink>
                    </span>
                </li>)
                )}
            </ul>
        </Col>
    </Row>)
};

export default QuickSelection;